import React from 'react'
import { StyleContentWrapper } from '../commons/ContentWrapper/style'
import { TextWrapper } from '../commons/Text'
import BiDirectionCard from '../commons/BidirectionalCard'

const FeaturesArr = [
  {
    imgSrc: '/servicesSvg/image1.svg',
    title: 'Order Medicine, In One Click',
    subTitle: `"Skip the pharmacy lines and get your prescribed medicines delivered right to your doorstep. We partner with trusted pharmacies to ensure fast, safe, and certified delivery. Ordering is simple, secure, and just a few taps away."`,
    direction: '',
  },
  {
    imgSrc: '/servicesSvg/image2.svg',
    title: 'In-Depth Search Tailored to You',
    subTitle: `"Find exactly what you're looking for, No more endless scrolling. Whether it's healthcare
services, medical products, or specialists, we bring all your options together in one place for
easy comparison."`,
    direction: 'reverse',
  },
  {
    imgSrc: '/servicesSvg/image3.svg',
    title: 'Book In-Home and Facility-Based Care Easily',
    subTitle: `"Whether you need a trained nurse at home or a trusted rehabilitation center, we make it easy
to find and book the right care. Browse verified services near you and schedule support in just
a few taps. Personalized, professional healthcare - delivered where it's needed most."`,
    direction: '',
  },
  {
    imgSrc: '/servicesSvg/image4.svg',
    title: 'Support That Cares',
    subTitle: `"Got a question or need a hand? Our friendly support team is always ready to guide you — with
real answers, real people, and real care. We're here to make your healthcare journey smoother,
every step of the way."`,
    direction: 'reverse',
  },
]

const Features = () => {
  return (
    <StyleContentWrapper paddingLeft="50" paddingRight="50">
      <TextWrapper
        title="Built with You in Mind"
        subtitle={`"Every feature is designed to make your healthcare journey smoother, smarter, and more personalized. We've simplified everything — so you can focus on feeling better."`}
        textWidth="700"
      />
      {FeaturesArr.map((feature, i) => {
        return (
          <BiDirectionCard
            key={i}
            imgSrc={feature.imgSrc}
            title={feature.title}
            subtitle={feature.subTitle}
            direction={feature.direction}
          />
        )
      })}
    </StyleContentWrapper>
  )
}

export default Features
